var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1153 2.66663C18.7414 2.66678 19.3474 2.8872 19.8273 3.28929L20.0007 3.44796L25.886 9.33329C26.3287 9.77599 26.6015 10.3603 26.6567 10.984L26.6673 11.2186V26.6666C26.6675 27.3394 26.4134 27.9874 25.956 28.4807C25.4985 28.974 24.8715 29.2762 24.2006 29.3266L24.0007 29.3333H8.00065C7.32788 29.3335 6.6799 29.0794 6.18659 28.622C5.69328 28.1645 5.39111 27.5375 5.34065 26.8666L5.33398 26.6666V5.33329C5.33377 4.66052 5.58786 4.01254 6.04531 3.51923C6.50277 3.02592 7.12978 2.72375 7.80065 2.67329L8.00065 2.66663H18.1153ZM16.0007 5.33329H8.00065V26.6666H24.0007V13.3333H18.0007C17.5035 13.3333 17.0241 13.1481 16.6561 12.8138C16.2881 12.4795 16.0577 12.0202 16.01 11.5253L16.0007 11.3333V5.33329ZM17.318 15.7973C17.6372 17.828 18.6991 19.6679 20.298 20.96C21.4806 21.916 20.3993 23.788 18.9806 23.2426C17.0626 22.5041 14.9387 22.5041 13.0207 23.2426C11.6007 23.7893 10.5193 21.916 11.702 20.96C13.3008 19.6679 14.3628 17.828 14.682 15.7973C14.9193 14.2946 17.082 14.296 17.318 15.7973ZM15.998 18.8693L15.0807 20.464H16.9206L15.998 18.8693ZM18.6673 5.88529V10.6666H23.4487L18.6673 5.88529Z",
    fill: "#8A8A8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4451e4b7573d1659dbfd60eacd73703e.svg";
export { ForwardRef as ReactComponent };